// Footer legal pages. SAMPLE TEXT — have the client (or their lawyer) review before going live.
const legal = {
  "privacy-policy": {
    title: "Privacy Policy",
    updated: "2026-10-01",
    sections: [
      {
        heading: "Our commitment",
        body: [
          "Unity Health Centre treats every patient's and family's information as strictly confidential. This policy explains what information we collect through this website and how we use it.",
        ],
      },
      {
        heading: "Information we collect",
        body: [
          "When you book an appointment or send us a message we collect the details you enter, such as your name, mobile number, email address, preferred date and time and your message.",
          "We do not ask for medical records through this website. Please share clinical information only during your consultation.",
        ],
      },
      {
        heading: "How we use it",
        body: [
          "We use your details only to contact you about your appointment or enquiry. We never sell or share your information with third parties for marketing.",
        ],
      },
      {
        heading: "Confidentiality of treatment",
        body: [
          "Information about consultations, admission and treatment is shared only with the clinical team caring for the patient, or with others when the patient (or legal guardian) agrees, or when the law requires it.",
        ],
      },
      {
        heading: "Contact",
        body: ["For any privacy question please call us or email info@unityhealthbd.com."],
      },
    ],
  },
  "terms-and-conditions": {
    title: "Terms & Conditions",
    updated: "2026-10-01",
    sections: [
      {
        heading: "Use of this website",
        body: [
          "The information on this website is for general awareness only and is not a substitute for professional medical advice, diagnosis or treatment.",
        ],
      },
      {
        heading: "Appointments",
        body: [
          "An appointment request submitted online is confirmed only after our reception team contacts you. Consultation times may change if a doctor is called to an emergency.",
        ],
      },
      {
        heading: "Admission & payment",
        body: [
          "Inpatient admission requires a minimum advance payment as stated in each package. Further payments are made fortnightly in advance and all dues must be cleared before discharge.",
          "Medicines, diagnostic tests and other items listed as 'Excludes' in a package are charged separately at actual cost.",
        ],
      },
      {
        heading: "Emergencies",
        body: [
          "In a medical or psychiatric emergency please call our emergency number or go to the nearest hospital immediately. Do not rely on online forms in an emergency.",
        ],
      },
    ],
  },
};

export default legal;
